import * as DMConst from "./DMConst";

export function getNavOptionStr(currID) {
    let optionStr;

    switch (currID) {
        case DMConst.introOp:
            optionStr = "Introduction";
            break;

        case DMConst.countryDashOp:
            optionStr = "Country dashboard";
            break;

        case DMConst.targCovBySNUOp:
            optionStr = "Target coverage by SNU";
            break;

        case DMConst.targPriorAchOp:
            optionStr = "1. Targets vs. prior achievements";
            break;

        case DMConst.progCovByAgeGroupOp:
            optionStr = "2. Progress in coverage, by age group";
            break;

        case DMConst.progCovBySNUOp:
            optionStr = "3. Progress in coverage, by SNU";
            break;

        case DMConst.covTableByAgeSNUOp:
            optionStr = "4. Coverage table by age/SNU";
            break;

        case DMConst.impactHIVInfectAvertOp:
            optionStr = "5. Impact - HIV infections averted";
            break;

        case DMConst.impactVMMCsReqOp:
            optionStr = "6. Impact - VMMCs required per HIV infection averted";
            break;

        case DMConst.progCovByCountryOp:
            optionStr = "7. Progress in coverage, by country";
            break;

        case DMConst.covTableByAgeCountryOp:
            optionStr = "8. Coverage table by age/country";
            break;

        case DMConst.agePriorAnal1Op:
            optionStr = "9a. Age prioritization analysis 1: VMMC done by age group and by year";
            break;

        case DMConst.agePriorAnal2Op:
            optionStr = "9b. Age prioritization analysis 2: Uptake of VMMC services by age group and by year";
            break;

        case DMConst.agePriorAnal3Op:
            optionStr = "9c. Age prioritization analysis 3: Increase in coverage";
            break;

        case DMConst.agePriorAnalOp:
            optionStr = "9 (a, b, c): Age prioritization analysis";
            break;

        case DMConst.agePriorAnal3UptakeCountryOp:
            optionStr = "10. Age prioritization analysis 3. Uptake rate by country";
            break;

        case DMConst.circumPopsByAgeGroupOp:
            optionStr = "11. Circumcised and uncircumcised male populations by age group";
            break;

        default:
            optionStr = "";
            break;
    }

    return optionStr;
}

export function isGlobalNavOptionBool(currID) {
    let isGlobalBool;

    switch (currID) {
        case DMConst.introOp:
        case DMConst.countryDashOp:
        case DMConst.progCovByCountryOp:
        case DMConst.covTableByAgeCountryOp:
        case DMConst.agePriorAnal3UptakeCountryOp:
            isGlobalBool = true;
            break;

        default:
            isGlobalBool = false;
            break;
    }

    return isGlobalBool;
}

export function isNonGlobalNavOptionBool(currID) {
    let isNonGlobalBool;

    switch (currID) {
        case DMConst.progCovByCountryOp:
        case DMConst.covTableByAgeCountryOp:
        case DMConst.agePriorAnal3UptakeCountryOp:
            isNonGlobalBool = false;
            break;

        default:
            isNonGlobalBool = true;
            break;
    }

    return isNonGlobalBool;
}

export function getVMMC_AgeGroupStr(currID) {
    let ageGroupStr;

    switch (currID) {
        case DMConst.ageEIMC_CurrID:
            ageGroupStr = "EIMC";
            break;

        case DMConst.age10t14CurrID:
            ageGroupStr = "10-14";
            break;

        case DMConst.age15t19CurrID:
            ageGroupStr = "15-19";
            break;

        case DMConst.age20t24CurrID:
            ageGroupStr = "20-24";
            break;

        case DMConst.age25t29CurrID:
            ageGroupStr = "25-29";
            break;

        case DMConst.age30t34CurrID:
            ageGroupStr = "30-34";
            break;

        case DMConst.age35t39CurrID:
            ageGroupStr = "35-39";
            break;

        case DMConst.age40t44CurrID:
            ageGroupStr = "40-44";
            break;

        case DMConst.age45t49CurrID:
            ageGroupStr = "45-49";
            break;

        case DMConst.age50t54CurrID:
            ageGroupStr = "50-54";
            break;

        case DMConst.age55t59CurrID:
            ageGroupStr = "55-59";
            break;

        default:
            ageGroupStr = false;
            break;
    }

    return ageGroupStr;
}

export function getYearIdx(year) {
    return year - DMConst.firstYear + 1;
}

export function getAgeGroupStartAgeDP(ageGroup) {
    let startAgeStr;

    switch (ageGroup) {
        case DMConst.DP_AllAges:
            startAgeStr = "All Ages";
            break;
        case DMConst.DP_Infant:
            startAgeStr = "EIMC";
            break;
        case DMConst.DP_A5_9:
            startAgeStr = "5";
            break;
        case DMConst.DP_A10_14:
            startAgeStr = "10";
            break;
        case DMConst.DP_A15_19:
            startAgeStr = "15";
            break;
        case DMConst.DP_A20_24:
            startAgeStr = "20";
            break;
        case DMConst.DP_A25_29:
            startAgeStr = "25";
            break;
        case DMConst.DP_A30_34:
            startAgeStr = "30";
            break;
        case DMConst.DP_A35_39:
            startAgeStr = "35";
            break;
        case DMConst.DP_A40_44:
            startAgeStr = "40";
            break;
        case DMConst.DP_A45_49:
            startAgeStr = "45";
            break;
        case DMConst.DP_A50_54:
            startAgeStr = "50";
            break;
        case DMConst.DP_A55_59:
            startAgeStr = "55";
            break;
        case DMConst.DP_A60_64:
            startAgeStr = "60";
            break;
        case DMConst.DP_A65_69:
            startAgeStr = "65";
            break;
        case DMConst.DP_A70_74:
            startAgeStr = "70";
            break;
        case DMConst.DP_A75_79:
            startAgeStr = "75";
            break;
        case DMConst.DP_A80_Up:
            startAgeStr = "80+";
            break;
        default:
            startAgeStr = "";
            break;
    }

    return startAgeStr;
}

export function getAgeGroupEndAgeDP(ageGroup) {
    let endAgeStr;

    switch (ageGroup) {
        case DMConst.DP_AllAges:
            endAgeStr = "All Ages";
            break;
        case DMConst.DP_Infant:
            endAgeStr = "EIMC";
            break;
        case DMConst.DP_A5_9:
            endAgeStr = "9";
            break;
        case DMConst.DP_A10_14:
            endAgeStr = "14";
            break;
        case DMConst.DP_A15_19:
            endAgeStr = "19";
            break;
        case DMConst.DP_A20_24:
            endAgeStr = "24";
            break;
        case DMConst.DP_A25_29:
            endAgeStr = "29";
            break;
        case DMConst.DP_A30_34:
            endAgeStr = "34";
            break;
        case DMConst.DP_A35_39:
            endAgeStr = "39";
            break;
        case DMConst.DP_A40_44:
            endAgeStr = "44";
            break;
        case DMConst.DP_A45_49:
            endAgeStr = "49";
            break;
        case DMConst.DP_A50_54:
            endAgeStr = "54";
            break;
        case DMConst.DP_A55_59:
            endAgeStr = "59";
            break;
        case DMConst.DP_A60_64:
            endAgeStr = "64";
            break;
        case DMConst.DP_A65_69:
            endAgeStr = "69";
            break;
        case DMConst.DP_A70_74:
            endAgeStr = "74";
            break;
        case DMConst.DP_A75_79:
            endAgeStr = "79";
            break;
        case DMConst.DP_A80_Up:
            endAgeStr = "80+";
            break;
        default:
            endAgeStr = "";
            break;
    }

    return endAgeStr;
}

export function getAgeGroupDP(ageGroup) {
    let ageGroupStr;

    switch (ageGroup) {
        case DMConst.DP_AllAges:
            ageGroupStr = "All Ages";
            break;
        case DMConst.DP_Infant:
            ageGroupStr = "EIMC";
            break;
        case DMConst.DP_A5_9:
            ageGroupStr = "5-9";
            break;
        case DMConst.DP_A10_14:
            ageGroupStr = "10-14";
            break;
        case DMConst.DP_A15_19:
            ageGroupStr = "15-19";
            break;
        case DMConst.DP_A20_24:
            ageGroupStr = "20-24";
            break;
        case DMConst.DP_A25_29:
            ageGroupStr = "25-29";
            break;
        case DMConst.DP_A30_34:
            ageGroupStr = "30-34";
            break;
        case DMConst.DP_A35_39:
            ageGroupStr = "35-39";
            break;
        case DMConst.DP_A40_44:
            ageGroupStr = "40-44";
            break;
        case DMConst.DP_A45_49:
            ageGroupStr = "45-49";
            break;
        case DMConst.DP_A50_54:
            ageGroupStr = "50-54";
            break;
        case DMConst.DP_A55_59:
            ageGroupStr = "55-59";
            break;
        case DMConst.DP_A60_64:
            ageGroupStr = "60-64";
            break;
        case DMConst.DP_A65_69:
            ageGroupStr = "65-69";
            break;
        case DMConst.DP_A70_74:
            ageGroupStr = "70-74";
            break;
        case DMConst.DP_A75_79:
            ageGroupStr = "75-79";
            break;
        case DMConst.DP_A80_Up:
            ageGroupStr = "80+";
            break;
        default:
            ageGroupStr = "";
            break;
    }

    return ageGroupStr;
}
